import { Navigate, Outlet } from "react-router-dom";
import { useAppContext } from "@/shared/hooks/useAppContext";
import { useIsAdmin } from "@/shared/hooks/useIsAdmin";
import CircularProgress from "@/shared/components/CircularProgress";
import FullscreenLayout from "@/pages/layouts/FullScreenLayout";
import { AUTH_ROUTES, POST_LOSS_ROUTES } from "@/shared/constants/paths";

/**
 * Wrapper for admin routes that require admin privileges
 * Redirects non-admin users to sign in or dashboard
 */
export function AdminRouteWrapper() {
  const { authUser } = useAppContext();
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return (
      <FullscreenLayout>
        <CircularProgress />
      </FullscreenLayout>
    );
  }

  if (!authUser) {
    return <Navigate to={AUTH_ROUTES.SIGN_IN} replace />;
  }

  if (!isAdmin) {
    // Redirect to dashboard if not admin
    return <Navigate to={POST_LOSS_ROUTES.OVERVIEW} replace />;
  }

  return <Outlet />;
}
